import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const CardPreOperationUX = (props: any) => {
    return(
      <div
        className="pre-operation-tabs"
        id="CardPreOperationUX-div-0">
        <div
          id="CardPreOperationUX-div-2"
          style={{ paddingTop: "4px", marginBottom: "-4px", display: "flex" }}>
          
          <Button
            color={props.containerName === "ORRequest" ? "blue":  undefined}
            id="CardPreOperationUX-Button-3"
            name="ORRequest"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px", display: "none"}}>
            {props.languageUX === "en" ? "OR Request" : "OR Request"}
          </Button>
          <Button
            color={props.containerName === "PreOPVisit" ? "blue":  undefined}
            id="CardPreOperationUX-Button-4"
            name="PreOPVisit"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px", }}>
            {props.languageUX === "en" ? "Pre-OP Visit" : "Pre-OP Visit"}
          </Button>
          <Button
            color={props.containerName === "ORRegistrationArea" ? "blue":  undefined}
            id="CardPreOperationUX-Button-5"
            name="ORRegistrationArea"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "OR Registration Area" : "OR Registration Area"}
          </Button>
          <Button
            color={props.containerName === "HoldingRoom" ? "blue":  undefined}
            id="CardPreOperationUX-Button-6"
            name="HoldingRoom"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "Holding Room" : "Holding Room"}
          </Button>
          <Button
            color={props.containerName === "AssessmentBundle" ? "blue":  undefined}
            disabled={true}
            id="CardPreOperationUX-Button-7"
            name="AssessmentBundle"
            onClick={props.onSetContainerName}
            style={{display: "none"}}>
            {props.languageUX === "en" ? "Initial Assessment" : "แบบประเมินแรกรับ"}
          </Button>
          <Button
            color={props.containerName === "ReassessmentBundle" ? "blue":  undefined}
            disabled={true}
            id="CardPreOperationUX-Button-8"
            name="ReassessmentBundle"
            onClick={props.onSetContainerName}
            style={{display: "none"}}>
            {props.languageUX === "en" ? "Exit Assessment Form" : "แบบประเมินออกจากห้องตรวจ"}
          </Button>
          <Button
            color="green"
            id="CardPreOperationUX-Button-10"
            name="printPreOperation"
            onClick={props.onPrint}
            style={{marginLeft: "auto"}}>
            {props.languageUX === "en" ? "Print Pre-Operative Form" : "พิมพ์ใบ Pre Operation"}
          </Button>
        </div>
        <hr
          id="CardPreOperationUX-hr-9">
        </hr>
      </div>
    )
}


export default CardPreOperationUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "pre-operation-tabs"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-div-0"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: \"4px\", marginBottom: \"-4px\", display: \"flex\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "OR Request",
          "valueEN": "OR Request"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"ORRequest\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-3"
        },
        "name": {
          "type": "value",
          "value": "ORRequest"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", display: \"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Pre-OP Visit",
          "valueEN": "Pre-OP Visit"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"PreOPVisit\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-4"
        },
        "name": {
          "type": "value",
          "value": "PreOPVisit"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "OR Registration Area",
          "valueEN": "OR Registration Area"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"ORRegistrationArea\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-5"
        },
        "name": {
          "type": "value",
          "value": "ORRegistrationArea"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Holding Room",
          "valueEN": "Holding Room"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"HoldingRoom\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "HoldingRoom"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "แบบประเมินแรกรับ",
          "valueEN": "Initial Assessment"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"AssessmentBundle\" ? \"blue\":  undefined"
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "AssessmentBundle"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "แบบประเมินออกจากห้องตรวจ",
          "valueEN": "Exit Assessment Form"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"ReassessmentBundle\" ? \"blue\":  undefined"
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-8"
        },
        "name": {
          "type": "value",
          "value": "ReassessmentBundle"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-hr-9"
        }
      },
      "seq": 9,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบ Pre Operation",
          "valueEN": "Print Pre-Operative Form"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPreOperationUX-Button-10"
        },
        "name": {
          "type": "value",
          "value": "printPreOperation"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrint"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"auto\"}"
        }
      },
      "seq": 10,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardPreOperationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
